import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import SVG from 'react-inlinesvg'
import { useCookies } from 'react-cookie'

import { getPageURL } from '../../utils/helpers/page-url'
import Link from '../parts/link'
import Image from '../parts/image'
import Markdown from '../parts/markdown'
import close from '../../assets/icons/close.svg'

const NotificationBanner = ({ data, className }) => {
  const [cookies, setCookie] = useCookies()
  const [isOpen, bannerIsOpen] = useState(true)

  if (!data || data === null || !data.enabled) {
    return
  }

  const CloseBanner = () => {
    bannerIsOpen(false)
    const currentDomain = `${getPageURL('domain')}`
    setCookie(data.cookieName, true, { domain: `${currentDomain}`, path: '/' })
  }

  const Banner = ({ enabled, type }) => {
    if (!type || !enabled) {
      return ''
    }

    let bannerWrapperClass = 'notification-banner-container'
    let bannerContentClass = 'notification-banner-content'

    if (type === 'cross-games' || type === 'promo' || type === 'crossPromo') {
      bannerWrapperClass = 'notification-banner-promo-container'
      bannerContentClass = 'notification-banner-promo-content'
    }

    return (
      <div className={`${bannerWrapperClass} relative mx-auto w-full max-w-[40rem] md:max-w-full`}>
        <button
          onClick={CloseBanner}
          className={`button-close duration-2500 absolute z-10 flex h-12 w-12 cursor-pointer items-center justify-center transition-all`}
        >
          <SVG
            onError={(error) => console.log(error.message)}
            cacheRequests={true}
            src={close}
            className="absolute z-10 h-5 w-5 text-white"
          />
        </button>
        <div className={`${bannerContentClass} relative w-full p-8 md:pl-32 pr-56 lg:w-auto`}>
          {data.text && (
            <Markdown
              className="mb-3 font-display text-base md:text-md font-bold uppercase tracking-wide text-white drop-shadow"
              children={data.text}
            />
          )}
          {data.crossLogo && (
            <Image
              media={data.crossLogo}
              className="mb-3 block w-80 md:w-96"
            />
          )}
          {data.linkUrl && (
            <Link
              to={data.linkUrl}
              className="inline-block font-sans text-base md:text-md text-white"
            >
              {data.linkText}
            </Link>
          )}
        </div>
        {data.img && (
          <Image
            media={data.img[0] ? data.img[0] : data.img}
            className="gatsby-absolute bottom-0 -z-1 md:z-10 right-0 md:-right-12 w-[21rem] md:w-96 pointer-events-none"
          />
        )}
      </div>
    )
  }

  if (data !== null) {
    return (
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, translateX: '100%' }}
            animate={{ opacity: 1, translateX: '0' }}
            exit={{ opacity: 0, translateX: '100%' }}
            transition={{
              duration: 0.5,
            }}
            className={`notification-banner ${className}`}
            tabIndex={0}
          >
            {!cookies[data.cookieName] && (
              <Banner
                enabled={data.enabled}
                type={data.type}
              />
            )}
          </motion.div>
        )}
      </AnimatePresence>
    )
  }
}

export default NotificationBanner
